import type { Entry } from "@/shared/types/entries";
import {
	ResponsiveDialog,
	ResponsiveDialogContent,
} from "@/v2/components/ui/responsive-dialog";
import { TooltipButton } from "@/v2/components/ui/tooltip-button";
import { ActionForm, type ActionFormSubmit } from "./action-dialog/ActionForm";

export interface MergeDialogProps {
	entries: Entry[];
	open: boolean;
	onOpenChange: (open: boolean) => void;
	conflicts?: { field: string; values: string[] }[];
	onSubmit: (values: ActionFormSubmit) => void;
}

export function MergeDialog({
	entries,
	open,
	onOpenChange,
	conflicts,
	onSubmit,
}: MergeDialogProps) {
	const formId = "merge-entries-form";
	return (
		<ResponsiveDialog open={open} onOpenChange={onOpenChange}>
			<ResponsiveDialogContent
				title="Merge"
				footer={
					<div className="flex justify-end items-center gap-2">
						<TooltipButton
							variant="outline"
							size="sm"
							onClick={() => onOpenChange(false)}
							tooltip="Cancel"
						>
							Cancel
						</TooltipButton>
						<TooltipButton
							type="submit"
							form={formId}
							size="sm"
							tooltip="Merge entries"
						>
							Merge entries
						</TooltipButton>
					</div>
				}
			>
				{entries.length > 0 && (
					<ActionForm
						formId={formId}
						entries={entries}
						conflicts={conflicts}
						showUnitsAggregation
						onSubmit={onSubmit}
					/>
				)}
			</ResponsiveDialogContent>
		</ResponsiveDialog>
	);
}
